import { Stack } from '@mui/material';
import { FlowDurationUnits } from 'flow-schema';

import { getSendEmailBlockVariables } from './baseContent';
import {
  TemplateInterpolationFallback,
  interpolateTemplateValues,
} from '../../../../../../../utils/string';
import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockDurationField } from '../../ConfigFields/Duration';
import { BlockHtmlField } from '../../ConfigFields/HtmlField';

export function SendEmailBlockFormFields() {
  return (
    <Stack spacing={2}>
      <BlockValueTemplateField
        fieldName="config.senderEmail"
        label="Sender Email"
        helperText="Provide a valid email address for the sender"
        placeholder="sender@example.com"
      />
      <BlockValueTemplateField
        fieldName="config.senderName"
        label="Sender Name"
        helperText="Provide a valid name for the sender"
        placeholder="Sender"
      />
      <BlockValueTemplateField
        fieldName="config.recipientEmail"
        label="Recipient Email"
        helperText="Provide a valid email address for the recipient"
        placeholder="recipient@example.com"
      />
      <BlockValueTemplateField
        fieldName="config.subject"
        label="Subject"
        helperText="Email subject line"
        placeholder="Your appointment confirmation"
      />
      <BlockHtmlField
        fieldName="config.content"
        label="Content"
        formatHtml={(html) =>
          interpolateTemplateValues(
            html,
            getSendEmailBlockVariables(),
            TemplateInterpolationFallback.Template
          )
        }
      />
      <BlockDurationField
        fieldName="config.timeout"
        unitFieldNameSuffix="units"
        allowedUnits={[
          FlowDurationUnits.Hours,
          FlowDurationUnits.Minutes,
          FlowDurationUnits.Seconds,
        ]}
        toggleLabel="Timeout"
        valueLabel="Timeout (fail after duration)"
      />
    </Stack>
  );
}
